
import React, { useState, useEffect } from 'react';
import Database from '../../../../../Helpers/Database.js';
import './styles.scss';

const db = new Database;


const Share = (props) =>{
    const property = props.property;
    const [favorite, setFavorite] = useState((props.favorites&&props.favorites.includes(property.id)) ? true : false);
    const [shareOptions, setShareOptions] = useState('');
    const [shareToggle, setShareToggle] = useState('closed');

    const handleFavorite = (e) => {
        e.stopPropagation();
        db.ajaxCall({
            action: 'favorite_property',
            property_id: property.id,
        })
            .then((res) => {
            if (res === 'prompt_login') {
                props.togglePropertyDetailsModal()
                $('#login-modal').addClass('redirected');
                $('#login-modal').fadeIn();
            } else {
                props.refreshUser()
                $('#favorites-count span').text(res.favorites_count)
                setFavorite(!favorite)
            }
        })
    }

    function toggleShareOptions() {
        if(shareToggle == 'closed'){
            setShareOptions(
                <div className="social-box-react">
                    <ul>
                        <li><a target="_blank" href={`https://twitter.com/intent/tweet?text=${property.permalink}`} title="Twitter"><i className="fab fa-twitter" aria-hidden="true"></i><span>Share on Twitter</span></a></li>
                        <li><a target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${property.permalink}`} title="Facebook"><i className="fab fa-facebook-f" aria-hidden="true"></i><span>Share on Facebook</span></a></li>
                        <li><a target="_blank" href={`https://www.linkedin.com/sharing/share-offsite/?url=${property.permalink}`} title="LinkedIn"><i className="fab fa-linkedin-in" aria-hidden="true"></i><span>Share on Linkedin</span></a></li>
                        <li className="copy-link-to-clipboard" data-permalink={property.permalink}><i className="fas fa-copy" aria-hidden="true"></i><span>Copy Link</span></li>
                    </ul>
                </div>
            )
            setShareToggle('open')
        }else{
            setShareOptions('');
            setShareToggle('closed');
        }
    }

    return(
        <div className="share">
            <button className="d-none d-md-flex" onClick={handleFavorite}>
                {
                    !favorite &&
                    <img className="default" src="/wp-content/themes/hayden/assets/images/icons/Save-Star.svg" alt="Save"/>
                }
                {
                    favorite &&
                    <img className="is-favorite" src="/wp-content/themes/hayden/assets/images/icons/Save-Star-Active.svg" alt="Save"/>
                }

                Save
            </button>
            <button className="position-relative" onClick={toggleShareOptions}>
                <img src="/wp-content/themes/hayden/assets/images/icons/green-share.svg" alt="close chevron"/>
                Share
                {shareOptions}
            </button>
            {property.brochure &&
                <a className="d-none d-md-flex" href={property.brochure} target="_blank" >
                    <img src="/wp-content/themes/hayden/assets/images/icons/printer-green.svg" alt="Print Property Brochure"/>
                    Print
                </a>}

        </div>
    )

}
export default Share
